import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import "./ExploreSection.css";
import { exploreData } from "../Datas/exploreData";
import ExploreSlider from "./ExploreSlider";
import arrow from "../images/downarrow.png";

const tabs = Object.keys(exploreData);

const ExploreSection = () => {
  const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("East");
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef();

  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentData = exploreData[activeTab];

  return (
    <section className="explore-section">
      <h2>EXPLORE WITH FLAMINGO</h2>

      {/* Tabs */}
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "tab active" : "tab"}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Header + Dropdown */}
      <div className="explore-header">
        <h3>EXPLORE {activeTab.toUpperCase()}</h3>
        
        <div className="dropdown" ref={dropdownRef}>
  <button
    className="dropdown-btn"
    onClick={() => {

      // IF ONLY ONE ITINERARY → DIRECT NAVIGATION
      if (currentData.itineraries.length === 1) {

        const routeName = currentData.itineraries[0]
          .toLowerCase()
          .replace(/\s+/g, "-");

        navigate(`/itinerary/${routeName}`);

      } else {

        // OTHERWISE OPEN DROPDOWN
        setOpenDropdown(!openDropdown);
      }
    }}
  >
    View {activeTab} Itineraries

    {/* SHOW ARROW ONLY IF MULTIPLE ITINERARIES */}
    {currentData.itineraries.length > 1 && (
      <img
        src={arrow}
        alt="arrow"
        className={
          openDropdown
            ? "downarrow rotate"
            : "downarrow"
        }
      />
    )}
  </button>

  {/* SHOW DROPDOWN ONLY IF MULTIPLE ITINERARIES */}
  {openDropdown &&
    currentData.itineraries.length > 1 && (

      <div className="dropdown-menu">

        {currentData.itineraries.map((item, index) => (

          <div
            key={index}
            className="dropdown-item"
            onClick={() => {

              const routeName = item
                .toLowerCase()
                .replace(/\s+/g, "-");

              navigate(`/itinerary/${routeName}`);

              setOpenDropdown(false);
            }}
          >
            {item}
          </div>

        ))}

      </div>
  )}
</div>
      </div>

      {/* Cards */}
      <ExploreSlider data={currentData.places} />
    </section>
  );
};

export default ExploreSection;